import { TConsumptionCategory } from '@/features/credits/types';
import React from 'react';
import { CONSUMPTION_CATEGORY_HOVER_EVENT } from '@/features/credits/config';

export const useIsActivityHighlighted = (category: TConsumptionCategory) => {
  const [isHighlighted, setIsHighlighted] = React.useState(false);

  const handleActivityHover = (e: Event) =>
    setIsHighlighted((e as CustomEvent).detail?.category === category);

  React.useEffect(() => {
    window.addEventListener(
      CONSUMPTION_CATEGORY_HOVER_EVENT,
      handleActivityHover,
    );

    return () =>
      window.removeEventListener(
        CONSUMPTION_CATEGORY_HOVER_EVENT,
        handleActivityHover,
      );
  }, []);

  return isHighlighted;
};
